import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/buffetConditions`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/buffetConditions`, payload);
};

const find = (merchantId, conditionCode, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/buffetConditions/${conditionCode}`,
		payload
	);
};

const update = (merchantId, conditionCode, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/buffetConditions/${conditionCode}`,
		payload
	);
};

const remove = (merchantId, conditionCode, payload) => {
	return Client.del(
		`${baseUrl}/${merchantId}/buffetConditions/${conditionCode}`,
		payload
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
